import classNames from 'classnames';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const SliderQuestion = ({
    onChange,
    answer,
    question_id,
    disabled,
    labels,
    useIcon,
    positiveText,
    negativeText,
    iconNegative,
    iconPositive
}) => {
    const [volume, setVolume] = useState(-1);
    const { i18n } = useTranslation();
    const handleOnChange = (value) => {
        setVolume(value);
        if (onChange) {
            onChange(value);
        }
    };

    useEffect(() => {
        if (answer && answer !== 'N/A') {
            setVolume(answer);
        } else {
            setVolume(-1);
        }
    }, [answer]);

    var hasNa = labels.find((x) => x.label === 'N/A');
    return (
        <Fragment>
            <div className="main-rating">
                <div className="rating-grid">
                    <ul className="rating__list">
                        {labels.map((it: any, buttonIndex: number) => {
                            if (it?.label === 'N/A') return null;
                            return (
                                <li key={`question-${question_id}-${buttonIndex}`}>
                                    <input
                                        disabled={disabled}
                                        onClick={() => handleOnChange(it)}
                                        type="radio"
                                        id={`rating-${question_id}-${buttonIndex}`}
                                        name={`question-${question_id}`}
                                        value={it?.label}
                                        checked={it?.label === volume}
                                        readOnly
                                        className={classNames('rating__field', {
                                            'btn--disable': disabled,
                                            active: it.label === volume
                                        })}
                                    />
                                    <label htmlFor={`rating-${question_id}-${buttonIndex}`} className="rating__label">
                                        <span>{it?.label}</span>
                                    </label>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {useIcon && (
                    <div className="slider-legends">
                        <div className="negative">
                            <i className={iconNegative}></i>
                        </div>
                        <div className="positive">
                            <i className={iconPositive}></i>
                        </div>
                    </div>
                )}
                {!useIcon && (
                    <div className="slider-legends-text">
                        <div className="negative">
                            {negativeText && negativeText[i18n.language] && negativeText[i18n.language].length > 0
                                ? negativeText[i18n.language][0]
                                : 'Unlikely'}
                        </div>
                        <div className="positive">
                            {positiveText && positiveText[i18n.language] && positiveText[i18n.language].length > 0
                                ? positiveText[i18n.language][0]
                                : 'Unlikely'}
                        </div>
                    </div>
                )}
            </div>
            {hasNa && (
                <div className="not-applicapable">
                    <button
                        disabled={disabled}
                        onClick={() => {
                            handleOnChange({
                                label: 'N/A',
                                value: 'N/A'
                            });
                        }}
                        className={classNames('add-rating btn-applicapable', { active: answer === 'N/A' })}>
                        N/A
                    </button>
                </div>
            )}
        </Fragment>
    );
};

export default SliderQuestion;
